import { Component, EventEmitter, Output } from '@angular/core';
// import { ErrorService } from 'src/app/services/error.service';
import { FirebaseService } from 'src/app/services/firebase.service';

@Component({
  selector: 'app-login-register',
  templateUrl: './login-register.component.html',
  styleUrls: ['./login-register.component.scss']
})
export class LoginRegisterComponent {
  @Output() signInClickEvent = new EventEmitter<string>();
  @Output() continueClickEvent = new EventEmitter<void>();


  constructor(
    public firebaseService: FirebaseService,
  ) {}

  handleLogin() {
    this.signInClickEvent.emit('login');
  }

  handleRegister() {
    this.signInClickEvent.emit('register');
  }

  continueWithoutLogIn() {
    this.continueClickEvent.emit();
  }
}
